import type { WindowDescriptor } from '@krp/client-runtime'
import type { ReceiptsUiState } from '../../reducer'
import { cashierAnalyticsPatched, decodeCashierAnalyticsIntent } from './model/analyticsSlice'

export const CASHIER_ANALYTICS_WINDOWS = { statistics: 'receipts.cashierAnalytics.statistics' } as const
const capture = (state: ReceiptsUiState) => ({ intent: state.cashierAnalytics })
const restore = (snapshot: Record<string, unknown>) => { const value = decodeCashierAnalyticsIntent(snapshot.intent); return value === undefined ? [] : [cashierAnalyticsPatched(value)] }
export const cashierAnalyticsWindows: readonly WindowDescriptor<ReceiptsUiState>[] = [
  { kind: CASHIER_ANALYTICS_WINDOWS.statistics, scope: 'global', paths: ['/receipts-service/cashiers'], label: 'Статистика кассира', menu: { group: 'work', order: 25, icon: 'cashier-stats', requires: 'platform:cashiers:read' }, capture, restore },
]
